var verizon = {
    drawerActionButton: null,
    certificateBalance: false,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    en: {
        termsAndConditionsLink: 'https://www.verizon.com/support/verizon-visa-card-rewards-legal/'
    },
    es: {
        termsAndConditionsLink: 'https://www.verizon.com/support/verizon-visa-card-rewards-legal/'
    },
    howToEarnPointsHeader: 'fullDetailsPage.verizonHowToEarnPointsHeader',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: false,
    links: [],
    translationViewPrintKey: null,
    DUAL_CARD: {
        actionButton: {
            text: 'shopMore.verizonButtonText',
            link: 'https://myvpostpay.verizon.com/ui/bill/secure/vzcc/db?#/'
        },
        banner: 'verizon-banner.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {
                grocery: {
                    icon: ['far', 'basket-shopping']
                },
                gas: { icon: ['far', 'gas-pump'] },
                dining: { icon: ['far', 'fork-knife'] },
                instore: { icon: ['far', 'mobile'] },
                billPay: { icon: ['far', 'calendar-day'] },
                world: { icon: ['far', 'earth-america'] },
                bonus: { icon: ['far', 'money-bills'] },
                adjustment: {
                    icon: ['far', 'calculator']
                }
            },
            titleKey: 'verizonEarnings.yourVerizonEarnings'
        },
        faqs: 'https://www.verizon.com/support/verizon-visa-card-faqs/',
        rewardsBalance: true,
        translationKey: 'faqs.verizonDescription',
        snapshotTranslationKey: 'faqs.verizonSnapshotDescription',
        valuePropImg: 'verizon-valueProp-dc.png',
        en: {
            propositions: [
                {
                    description: 'Earn 4% back in Verizon Dollars on purchases at grocery stores, gas & EV charging stations and restaurants & takeout*',
                    heading: 'earn',
                    points: '4% back'
                },
                {
                    description: 'Earn 4% back in Verizon Dollars on Verizon purchases*†',
                    heading: 'earn',
                    points: '4% back'
                },
                {
                    description: 'Earn 1% back in Verizon Dollars when you pay your Verizon bill*',
                    heading: 'earn',
                    points: '1% back'
                },
                {
                    description: 'Earn 1% back in Verizon Dollars on all other purchases*',
                    heading: 'earn',
                    points: '1% back'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga un 4% de reembolso en Verizon Dollars en compras de tiendas de comestibles, gasolineras y estaciones de carga para vehículos eléctricos, restaurantes y comida para llevar*',
                    heading: 'obtenga',
                    points: '4% de reembolso'
                },
                {
                    description: 'Obtenga un 4% de reembolso en Verizon Dollars en compras de Verizon*†',
                    heading: 'obtenga',
                    points: '4% de reembolso'
                },
                {
                    description: 'Obtenga un 1% de reembolso en Verizon Dollars cuando pague su factura mensual de Verizon*',
                    heading: 'obtenga',
                    points: '1% de reembolso'
                },
                {
                    description: 'Obtenga un 1% de reembolso en Verizon Dollars en todas las demás compras*',
                    heading: 'obtenga',
                    points: '1% de reembolso'
                }
            ]
        }
    }
};
export default verizon;
